export enum LOYALTY_LEVEL_NAMES {
  level01 = 'levels-1',
  level02 = 'levels-2',
  level03 = 'levels-3',
  level04 = 'levels-4',
  level05 = 'levels-5',
}

export const LOYALTY_LEVELS_ORDER = Object.values(LOYALTY_LEVEL_NAMES)
